module.exports = __webpack_public_path__ + "img/avatar-3.16b3c67f.png";